import axios from 'axios';
import { MainUrl } from "../../constants"

export function createGet(endpoint) {
  return async (token, id) => {
    const response = await axios.get(`${MainUrl}/${endpoint}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  };
}

export function createGetByDates(endpoint){
    return async (token, startDate, endDate) => {
        const response = await axios.get(`${MainUrl}/${endpoint}/?start_date=${startDate}&end_date=${endDate}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
    }
}

export function createPost(endpoint){
  return async (token, body) => {
    try {
        const response = await axios.post(`${MainUrl}/${endpoint}/`, body,
        {
        headers: {
          Authorization: `Bearer ${token}`
        }
        });
        return response.data
    } 
  catch(error){
    if (error.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("access_level");
        window.location.href = "/";
      }
      return error.response.data;
  }
  }
}

export function createPatch(endpoint){
  return async (token, id, body) => {
    try {
        const response = await axios.patch(`${MainUrl}/${endpoint}/${id}`, body,
        {
        headers: {
          Authorization: `Bearer ${token}`
        }
        });
        return response.data
    } 
  catch(error){
    if (error.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("access_level");
        window.location.href = "/";
      }
      return error.response.data;
  }
  }
}

export function createDownload(endpoint){
    return async (token, startDate, endDate) => {
      try{
        const response = await axios.get(`${MainUrl}/${endpoint}/?start_date=${startDate}&end_date=${endDate}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    responseType: "blob",
  });
  return response
    }
    catch(error){
    if (error.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("access_level");
        window.location.href = "/";
      }
      return error.response.data;
  }
    }
}


// try {
//     const response = await axios.get(
//       `${API_URL}/chk/?start_date=${startDate}&end_date=${endDate}`,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         responseType: "blob",
//       }
//     );
//     return response;
//   } catch (error) {
//     // if (error.status == 401) {
//     //   localStorage.removeItem("token");
//     //   localStorage.removeItem("access_level");
//     //   window.location.href = "/";
//     // }
//     return error.response.data;
//   }